export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.vueApp.config.errorHandler = (error, vm, info) => {
		umamiTrack("error", {
			error: (error as Error).message,
			stack: (error as Error).stack,
			info: info,
			vm: vm,
			timestamp: new Date().toISOString(),
		});
		console.error("An error occurred:", error);
	};
});
